var _style, _circle, _ellipse, _ellipse2, _ellipse3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactionWow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1500",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ffda6b}.st1{fill:#262c38}.st2{fill:none;stroke:#262c38;stroke-width:60;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 750,
    cy: 750,
    r: 750
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 748.3,
    cy: 1046.3,
    rx: 220.6,
    ry: 297.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-81.396 402.197 564.888)",
    className: "st1",
    cx: 402.2,
    cy: 564.9,
    rx: 155.6,
    ry: 109.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-8.604 1093.463 564.999)",
    className: "st1",
    cx: 1093.2,
    cy: 564.9,
    rx: 109.2,
    ry: 155.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.9 223s69.7-96.7 174-28.6M1177.5 223s-69.7-96.7-174-28.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionWow);
export default __webpack_public_path__ + "static/media/reaction_wow.63bc5f65cc591e26540fb85ba10bffa6.svg";
export { ForwardRef as ReactComponent };